
class OnboardTemplate {
  constructor(title, img, steps){
    this.title = title;
    this.img = `https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/${img}.png`;
    this.steps = steps;
  }
}

class Step {
  constructor(title, progLabel, subSteps, hover){
    this.title = title;
    this.progLabel = progLabel;
    this.subSteps = subSteps;
    this.hover = hover;
  }
}

class SubStep {
  constructor(inputs){
    this.inputs = inputs;
  }
}

class Input {
  constructor(label, optional, val, type, prefill){
    this.label = label;
    this.optional = optional;
    this.val = val;
    this.type = type;
    if (prefill) this.prefill = prefill;
  }
}

export default {

  access: new OnboardTemplate(
    'title',
    'enterprise',
    [
      new Step(
        'pers',
        'admin',
        [
          new SubStep(
            [
              new Input('email', false, 'email', 'input'),
              new Input('fName', false, 'firstName', 'input'),
              new Input('lName', false, 'lastName', 'input')
            ]
          ),
        ]
      ),
      new Step(
        'orgDetails',
        'comp',
        [
          new SubStep(
            [
              new Input('orgName', false, 'org', 'input'),
              new Input('phoneNum', true, 'phoneNumber', 'input', '+')
            ]
          )
        ]
      ),
      new Step(
        'country',
        'country',
        [
          new SubStep(
            [
              new Input('searchCountry', false, 'country', 'searchList')
            ]
          )
        ]
      ),
      new Step(
        'address',
        'address',
        [
          new SubStep(
            [
              new Input('street', false, 'street', 'input'),
              new Input('city', false, 'city', 'input'),
              new Input('state', true, 'state', 'input'),
              new Input('zipCode', false, 'zipCode', 'input')
            ]
          )
        ]
      )
    ]
  ),

  bldg: new OnboardTemplate(
    'newBldg',
    'company',
    [
      new Step(
        'country',
        'country',
        [
          new SubStep(
            [
              new Input('searchCountry', false, 'country', 'searchList')
            ]
          )
        ]
      ),
      new Step(
        'city',
        'city',
        [
          new SubStep(
            [
              new Input('searchCity', false, 'city', 'searchList')
            ]
          )
        ],
        {
          "type": "full",
          "temp": "ObBldg",
          "instance": "ApproximateLocation"
        }
      ),
      new Step(
        'address',
        'address',
        [
          new SubStep(
            [
              new Input('street', false, 'street', 'input'),
              new Input('streetExtended', true, 'streetExtended', 'input'),
              new Input('zipCode', false, 'zipCode', 'input')
            ]
          )
        ],
        {
          type: 'full',
          temp: 'ObBldg',
          instance: 'PreciseLocation'
        }
      ),
      new Step(
        'bldgType',
        'type',
        [
          new SubStep(
            [
              new Input('bldgType', false, 'type', 'searchList')
            ]
          )
        ]
      ),
      new Step(
        'bldgInfo',
        'info',
        [
          new SubStep(
            [
              new Input('bldgName', false, 'name', 'input'),
              new Input('above', false, 'aboveGround', 'number'),
              new Input('below', false, 'belowGround', 'number', '0')
            ]
          )
        ],
        {
          type: 'media',
          temp: 'ObBldg',
          instance: 'FloorAssignments'
        }
      )
    ]
  ),

  room: new OnboardTemplate(
    'newRoom',
    'doorWhite',
    [
      new Step(
        'enterAPSN',
        'device',
        [
          new SubStep(
            [
              new Input('locatedUnder', false, 'apid', 'apid')
            ]
          )
        ]
      ),
      new Step(
        'rInfo',
        'info',
        [
          new SubStep(
            [
              new Input('fName', false, 'floorName', 'input'),
              new Input('rName', false, 'hvacName', 'input')
            ]
          )
        ]
      ),
      new Step(
        'eInfo',
        'equip',
        [
          new SubStep(
            [
              new Input('type', false, 'altConfig', 'searchList')
            ]
          ),
          new SubStep(
            [
              new Input('manuf', true, 'manufacturer', 'input'),
              new Input('modelNum', true, 'modelNumber', 'input')
            ]
          )
        ]
      ),
      new Step(
        'fInfo',
        'filter',
        [
          new SubStep(
            [
              new Input('fType', false, 'fType', 'searchList')
            ]
          ),
          new SubStep(
            [
              new Input('len', false, 'length', 'size'),
              new Input('wid', false, 'width', 'size'),
              new Input('dep', false, 'depth', 'size'),
              new Input('fBrand', true, 'fBrand', 'input'),
              new Input('fModel', true, 'fModel', 'input')
            ]
          )
        ]
      )
    ]
  ),

  user: new OnboardTemplate(
    'newUser',
    'profile',
    [
      new Step(
        'uInfo',
        'Info',
        [
          new SubStep(
            [
              new Input('email', false, 'email', 'input'),
              new Input('fName', false, 'firstName', 'input'),
              new Input('lName', false, 'lastName', 'input'),
              new Input('jobTitle', true, 'jobTitle', 'input'),
              new Input('phoneNum', true, 'phoneNumber', 'input')
            ]
          )
        ]
      )
    ]
  )

}



// WEBPACK FOOTER //
// ./src/lib/obTemplates.js